module.exports = __webpack_public_path__ + "img/question-form.668b3bd4.png";